import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import formatDate from 'date-fns/format';
import parse from 'date-fns/parse';
import parseISO from 'date-fns/parseISO';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { loadPackage } from '@panneau/core/utils';

var propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  format: PropTypes.string,
  parseFormat: PropTypes.string,
  locale: PropTypes.string,
  localeLoaders: PropTypes.objectOf(PropTypes.func)
};
var defaultProps = {
  value: null,
  placeholder: null,
  format: 'yyyy-MM-dd',
  parseFormat: null,
  locale: null,
  localeLoaders: {
    fr: function fr() {
      return loadPackage('date-fns/locale/fr-CA', function () {
        return import('date-fns/locale/fr-CA');
      });
    },
    de: function de() {
      return loadPackage('date-fns/locale/de', function () {
        return import('date-fns/locale/de');
      });
    },
    ja: function ja() {
      return loadPackage('date-fns/locale/ja', function () {
        return import('date-fns/locale/ja');
      });
    },
    es: function es() {
      return loadPackage('date-fns/locale/es', function () {
        return import('date-fns/locale/es');
      });
    },
    en: function en() {
      return loadPackage('date-fns/locale/en-US', function () {
        return import('date-fns/locale/en-US');
      });
    }
  }
};
var DateDisplay = function DateDisplay(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    format = _ref.format,
    parseFormat = _ref.parseFormat,
    locale = _ref.locale,
    localeLoaders = _ref.localeLoaders;
  var _useIntl = useIntl(),
    defaultLocale = _useIntl.locale;
  var finalLocale = locale || defaultLocale;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    localePackage = _useState2[0],
    setLocalePackage = _useState2[1];
  useEffect(function () {
    if (typeof localeLoaders[finalLocale] !== 'undefined') {
      localeLoaders[finalLocale]().then(function (_ref2) {
        var newLocalePackage = _ref2["default"];
        return setLocalePackage(newLocalePackage);
      });
    }
  }, [finalLocale, localeLoaders]);
  var date = useMemo(function () {
    if (value === null) {
      return null;
    }
    var newDate = null;
    try {
      var parsed = parseFormat !== null ? parse(value, parseFormat, new Date()) : parseISO(value);
      newDate = parsed ? formatDate(parsed, format, localePackage !== null ? {
        locale: localePackage
      } : {}) : null;
    } catch (_unused) {
      console.error('An error occured parsing or formatting date');
      newDate = value !== null ? value : null;
    }
    return newDate;
  }, [localePackage, value, format, parseFormat]);
  return /*#__PURE__*/React.createElement("div", null, date || placeholder);
};
DateDisplay.propTypes = propTypes;
DateDisplay.defaultProps = defaultProps;

export { DateDisplay as default };
